import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  flex-grow: 1;
  justify-content: flex-end;
  gap: .7rem;
  margin-top: .5rem;
`

export const ContainerItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  gap: 1rem;
`

export const ContainerInfo = styled.div`
  width: 100%;
  padding: 0 .4rem 0 .4rem;
`

export const ContainerType = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  padding: .5rem .3rem .7rem .3rem;
`

export const ContainerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 .4rem 0 .4rem;
  width: 100%;
  height: 2.5rem;
`

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 .6rem 1rem .6rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 9rem;    
  height: 2.5rem !important;
  margin: 0 !important;
`

export const ConfirmModalContainer = styled.span`
  display: grid;
`

export const ConfirmModalText = styled.label`
  font-size: 15px;
`

export const ConfirmModalConfirmationText = styled.label`
  font-size: 15px;
  font-weight: bold;
  text-align: end;
  margin-top: 10px !important;
`
